import { QuoteMainFragment } from '../../../../../generated/graphql'

export const getPossibleExcessOptions = (quote: QuoteMainFragment) => {
  const allExcesses = quote?.possibleVoluntaryExcesses || []
  const vehicleValue = quote?.details?.vehicle?.current_value
  if (!vehicleValue) return allExcesses.includes(0) ? allExcesses : [0, ...allExcesses]

  let maxExcessValue = vehicleValue - 500
  if (maxExcessValue < 0) maxExcessValue = 0

  const possibleExcesses = allExcesses.filter((excess: number) => excess <= maxExcessValue)

  return possibleExcesses.includes(0) ? possibleExcesses : [0, ...possibleExcesses]
}
